<template>
  <div class="PDFdom">
    <div id="pdfDom" class="pdf">
      <!-- 公司/用户信息 -->
      <div class="companyInfo">
        <div class="logo">
          <img src="@/assets/logo.jpeg" />
          <div class="title">FACTURA</div>
        </div>
        <div class="infos">
          <div class="left">
            <div class="infoItem">{{ companyInfo.company_name }}</div>
            <div class="infoItem">CIF: {{ companyInfo.duty }}</div>
            <div class="infoItem">Dirección: {{ companyInfo.address }}</div>
            <div class="infoItem">C.P.: {{ companyInfo.code }}</div>
            <div class="infoItem">Telf.: {{ companyInfo.tel }}</div>
            <div class="infoItem">Email: {{ companyInfo.emai }}</div>
          </div>
          <div class="right">
            <div class="infoItem"><span class="itemName">Fectura:</span>{{ userInfo.count_sn }}</div>
            <div class="infoItem"><span class="itemName">Fecha:</span>{{ userInfo.count_time }}</div>
            <div class="infoItem"><span class="itemName">Número:</span>{{ userInfo.user_id }}</div>
            <div class="infoItem"><span class="itemName">Nombre:</span>{{ userInfo.name }}</div>
            <div class="infoItem"><span class="itemName">DireccIon:</span>{{ userInfo.address }}</div>
            <div class="infoItem"><span class="itemName">Email:</span>{{ userInfo.email }}</div>
            <div class="infoItem"><span class="itemName">CIF/NIF:</span>{{ userInfo.tax_code }}</div>
          </div>
        </div>
      </div>
      <!-- 记录列表 -->
      <table class="table" border="1">
        <tr class="tHead">
          <th style="width: 130px;">FECHA</th>
          <th>ALBARAN</th>
          <th>LINEA</th>
          <th>REMITENTE</th>
          <th>DESTINATARIO</th>
          <th>PESO (KG)</th>
          <th>IMPORTE (€)</th>
          <th>SEGURO (€)</th>
          <th>RECOGIDA (€)</th>
          <th>DESCUENTO (€)</th>
          <th>IVA 21%</th>
          <th>TOTAL (€)</th>
        </tr>
        <tr v-for="(val, key) in list" :key="key">
          <td style="width: 130px;">{{ val.create_time }}</td>
          <td>{{ val.line_no[0] }}</td>
          <td>{{ val.service }}</td>
          <td>{{ val.send_name }}</td>
          <td>{{ val.receive_name }}</td>
          <td>{{ val.weight }}</td>
          <td>{{ val.price }}</td>
          <td>{{ val.fee }}</td>
          <td>{{ val.pick_price }}</td>
          <td>{{ val.discount }}</td>
          <td>{{ val.iva }}</td>
          <td>{{ val.total_price }}</td>
        </tr>
      </table>

      <div class="total">
        <div class="items">
          <div class="item">
            <span>Bruto</span>
            <span>{{ total.total_acount }}€</span>
          </div>
          <div class="item">
            <span>IVA</span>
            <span>{{ total.total_iva }}€</span>
          </div>
          <div class="item">
            <span>Importe Total</span>
            <span>{{ total.total_all }}€</span>
          </div>
        </div>
      </div>
      <div class="tips">{{ tip }}</div>
    </div>
  </div>
</template>

<script>
import member from '@/api/member';
export default {
  name: 'exportPDF',
  props: {
    orderId: String,
  },
  watch: {
    orderId(res) {
      if (res) {
        this.getContent(parseInt(res));
      }
    },
  },
  data() {
    return {
      companyInfo: {},
      userInfo: {},
      list: [],
      total: {},
      tip: '',
    };
  },
  created() {},
  methods: {
    getContent(id) {
      member.downLoadUserBills({ id: id }).then(res => {
        this.companyInfo = res.data.company;
        this.userInfo = res.data.user;
        this.list = res.data.list;
        this.total = {
          total_acount: res.data.total_acount,
          total_all: res.data.total_all,
          total_iva: res.data.total_iva,
        };
        this.tip = res.data.content;
        this.$nextTick(() => {
          this.download();
        });
      });
    },
    download() {
      this.getPdf('发票');
      this.$emit('done');
    },
    dealImage(path, callback) {
      console.log(path);
      var img = new Image();
      img.src = path;
      img.onload = function() {
        //默认按比例压缩
        var w = this.width,
          h = this.height;
        var quality = 0.95; // 默认图片质量为0.7

        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // 创建属性节点
        canvas.setAttribute('width', w);
        canvas.setAttribute('height', h);

        ctx.drawImage(this, 0, 0, w, h);
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        callback(base64);
        console.log(base64);
      };
    },
  },
};
</script>

<style lang="less" scoped>
.PDFdom {
  position: fixed;
  top: -999vh;
  .pdf {
    padding: 0 20px;
    .companyInfo {
      margin-bottom: 20px;
      .logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        & > img {
          width: 300px;
        }
        .title {
          font-size: 30px;
          font-weight: bolder;
          padding-right: 30px;
        }
      }
      .infos {
        display: flex;
        justify-content: space-between;
        font-size: 30px;
        // align-items: flex-;
        .left {
          .infoItem:first-child {
            font-weight: bolder;
          }
        }
        .right {
          .infoItem {
            .itemName {
              font-weight: bolder;
              margin-right: 5px;
            }
          }
        }
      }
    }
    .table {
      font-size: 20px;
      width: 100%;
      .tHead {
        background: rgb(39, 69, 99);
        color: #fff;
      }
      tr {
        text-align: center;
        line-height: 40px;
      }
    }
    .total {
      display: flex;
      justify-content: flex-end;
      margin: 40px 0;
      font-size: 20px;
      font-weight: bolder;
      .items {
        width: 300px;
        .item {
          padding-right: 50px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
